import { render, staticRenderFns } from "./ListPurchaseRequisition.vue?vue&type=template&id=887fff76&scoped=true&"
import script from "./ListPurchaseRequisition.vue?vue&type=script&lang=ts&"
export * from "./ListPurchaseRequisition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "887fff76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('887fff76')) {
      api.createRecord('887fff76', component.options)
    } else {
      api.reload('887fff76', component.options)
    }
    module.hot.accept("./ListPurchaseRequisition.vue?vue&type=template&id=887fff76&scoped=true&", function () {
      api.rerender('887fff76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchasing/purchase-requisition/ListPurchaseRequisition.vue"
export default component.exports